export const MapViewLegendConsts = {
    JOB_LEAD: "Job Lead",
    MATERIAL_AND_TRUCKING_DETAILS: "Material & Trucking details",
    BUILD_QUOTE: "Build Quote",
    QUOTE_SHARED: "Quote Shared",
    QUOTE_APPROVED: "Quote Approved",
    INTERNAL_APPROVAL: "Internal Approval",
    INTERNAL_APPROVAL_DRAFT: "Internal Approval Draft",
    DISPATCH_APPROVED: "Dispatch Approved",
    LEAD_MARKER_ALT: "black-marker",
    MATERIAL_AND_TRUCKING_DETAILS_ALT: "violet-marker",
    BUILD_QUOTE_ALT: "green-marker",
    QUOTE_SHARED_ALT: "orange-marker",
    QUOTE_APPROVED_ALT: "brown-marker",
    INTERNAL_APPROVAL_ALT: "red-marker",
    INTERNAL_APPROVAL_DRAFT_ALT: "light-brown-marker",
    DISPATCH_APPROVED_ALT: "blue-marker",
};
